module.exports = __webpack_public_path__ + "img/image-1.5db8a05d.png";